














import { codigo_cliente } from '~/store/auth';
import { Favorito, favorito_repository, favoritos, loadFavoritos } from '~/store/favoritos';
import DialogModal from '../DialogModal.vue';
import Swal from 'sweetalert2';


export default {
    components: {
        DialogModal
    },
    props: {
        name: {
            type: String,
            required: true
        }
    },
    methods: {
        async toggle() {
            
            if (this.favorito !== null) {
                const { isConfirmed } = await Swal.fire({
                    title: "Deseja remover o favorito?",
                    showCancelButton: true,
                    confirmButtonText: "Sim",
                    cancelButtonText: 'Não'
                })
                if (!isConfirmed) {
                    return
                }
                await favorito_repository.delete(this.favorito.id)
            } else {
                const { isConfirmed, value } = await Swal.fire<{ condominios: boolean, perfis: boolean}>({
                    title: "Adicionar aos favoritos",
                    focusConfirm: false,
                    preConfirm: () => {
                        return {
                            condominios: (document.getElementById('swal2-input-condominios') as HTMLInputElement)?.checked || false,
                            perfis: (document.getElementById('swal2-input-perfis') as HTMLInputElement)?.checked || false,
                        }
                    },
                    html: `
                        <div style="display:flex;flex-direction: column;align-items:center;">
                            <div style="width: 300px">
                                <label style="display: flex; align-items:center">
                                    <input type="checkbox" id="swal2-input-condominios" value="1" class="swal2-input" style="width:16px;height:16px" />
                                    Adicionar a todos os condomínios
                                </label>
                            </div>
                            <div style="width: 300px">
                                <label style="display: flex; align-items:center">
                                    <input type="checkbox" id="swal2-input-perfis" value="1" class="swal2-input" style="width:16px;height:16px"  />
                                    Adicionar a todos os perfis
                                </label>
                            </div>
                        </div>
                    `
                })

                let codigo_condominio = this.codigo_condominio
                let tipo_relacao = this.tipo_relacao
                if (value) {
                    if (value.condominios) {
                        codigo_condominio = 0
                    }
                    if (value.perfis) {
                        tipo_relacao = ''
                    }
                }

                if (!isConfirmed) {
                    return
                }

                await favorito_repository.save({
                    id: window.crypto.randomUUID(),
                    menu: this.name,
                    codigo_cliente: this.codigo_cliente,
                    codigo_condominio,
                    tipo_relacao
                })
            }
            await loadFavoritos()
        }
    },
    computed: {
        favorito(): Favorito|null {
            let record = this.favoritos.find((favorito) => {
                if (favorito.menu !== this.name) {
                    return false
                }
                if ('' === this.tipo_relacao) {
                    return false
                }

                if (favorito.codigo_condominio !== 0 && favorito.codigo_condominio !== this.codigo_condominio) {
                    return false
                }
                if (favorito.tipo_relacao !== '' && favorito.tipo_relacao !== this.tipo_relacao) {
                    return false
                }

                return true
            })
            if (!record) {
                return null
            }
            return record
        },
        is_favorite(): boolean {
            return null !== this.favorito
        },
        condominio() {
            return this.$store.getters.condominio;
        },    
        codigo_cliente(): number {
            return codigo_cliente.value
        },
        codigo_condominio(): number { 
            if (!this.condominio) {
                return 0;
            }
            return Number(this.condominio?.codigo||'0');
        },
        tipo_relacao(): string {
            return this.$store.getters.relacao?.tipoRelacao;
        },
        favoritos(): Favorito[] {
            return favoritos.value
        }
    }
}

